import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getBenefitIcon } from '../../module/benefits/BenefitIcon';

import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { BenefitPaper } from '../../component/benefitTabs/BenefitPaper';
import BenefitSubPage from '../../module/benefits/BenefitSubPage';
import CarConnectPanel from '../../module/benefits/car/CarConnectPanel';

import { AuthorizedLayout } from '../../module/navigation/AuthorizedLayout';

const CarConnectPage: React.FC = () => {
  const { t } = useTranslation('benefitsModule');
  const navigate = useNavigate();

  const handleConnected = useCallback(() => {
    navigate('/benefits/car/settings');
  }, [navigate]);

  return (
    <AuthorizedLayout title={t('CAR.settings.title')} breadcrumbs={[{ title: t('CAR.title'), to: '/benefits/car' }]}>
      <BenefitSubPage icon={getBenefitIcon(BenefitDTOBenefitEnum.Car)} title={t('CAR.title')} subTitle={t('CAR.settings.title')}>
        <BenefitPaper sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <CarConnectPanel onConnected={handleConnected} />
        </BenefitPaper>
      </BenefitSubPage>
    </AuthorizedLayout>
  );
};

export default CarConnectPage;
